import { useEffect, useState } from "react";
import PortfolioList from "./PortfolioList";
import "./Portfolio.scss";
import {
  featuredPortfolio,
  webPortfolio,
  clientPortfolio,
  mobilePortfolio,
  gamesPortfolio,
  instrumentalsPortfolio,
} from "../../data";

export default function Portfolio() {
  const [selected, setSelected] = useState("featured");
  const [data, setData] = useState([]);
  const list = [
    {
      id: "featured",
      title: "Featured",
    },
    {
      id: "web",
      title: "Web Apps",
    },
    {
      id: "freelance",
      title: "Client Projects",
    },
    {
      id: "mobile",
      title: "Mobile Apps",
    },
    {
      id: "games",
      title: "Games",
    },
    {
      id: "music",
      title: "Instrumentals",
    },
  ];

  useEffect(() => {
    switch (selected) {
      case "featured":
        setData(featuredPortfolio);
        break;
      case "web":
        setData(webPortfolio);
        break;
      case "freelance":
        setData(clientPortfolio);
        break;
      case "mobile":
        setData(mobilePortfolio);
        break;
      case "games":
        setData(gamesPortfolio);
        break;
      case "music":
        setData(instrumentalsPortfolio);
        break;
      default:
        setData(featuredPortfolio);
    }
  }, [selected]);

  return (
    <div className="portfolio" id="portfolio">
      <h1>Portfolio</h1>
      <ul>
        {list.map((item) => (
          <PortfolioList
            title={item.title}
            active={selected === item.id}
            setSelected={setSelected}
            id={item.id}
          />
        ))}
      </ul>
      <div className="container">
        {data.map((d) => (
          <div className="item">
            <img src={d.img} alt="" />
            <h3>
              <a href={d.link} target="_blank" rel="noreferrer">
                {d.title}
              </a>
            </h3>
          </div>
        ))}
      </div>
    </div>
  );
}
